import { useState } from "react";
import Table, { localCustomStyles } from "../../../../components/tables/Table";
import { PERMISSIONS } from "../../../PermissionsConstants";
import SaveButton from "../../../../components/SaveButton";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  agmtEditMassUpload,
  agmtMassUploadData,
  agmtAllMassUploadData,
} from "../atoms/atoms";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useSaveMassUpload from "../hooks/useSaveMassUpload";
import { toast } from "../../../../components/toastNotification";

export const MassUploadTable = ({
  data,
  columns,
  onSelectedRowsChange,
  selectedRows,
  setOpenModal,
  setIsBulkSelected,
  clearSelectedRows,
  isLoading,
  agmtRefetch,
  setActiveTab,
}) => {
  const allMassUploadData = useRecoilValue(agmtAllMassUploadData);
  const massUploadData = useRecoilValue(agmtMassUploadData);
  const [, setAllMassUploadData] = useRecoilState(agmtAllMassUploadData);
  const [, setMassUploadData] = useRecoilState(agmtMassUploadData);
  const isEditState = useRecoilValue(agmtEditMassUpload);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [uploading, setUploading] = useState(false);
  const { mutateAsync: uploadValidData } = useSaveMassUpload();
  const validMassUpload = allMassUploadData?.filter(
    (x) =>
      x.condition.toLowerCase() === "valid" ||
      x.condition.toLowerCase() === "conflicting effective dates"
  );
  const handleSave = () => {
    setOpenConfirm(false);
    setUploading(true);
    uploadValidData(validMassUpload, {
      onSuccess: (res) => {
        setUploading(false);
        if (res) {
          if (res.status === 200) {
            setAllMassUploadData(
              allMassUploadData.filter(
                (x) =>
                  x.condition.toLowerCase() !== "valid" &&
                  x.condition.toLowerCase() !== "conflicting effective dates"
              )
            );
            setMassUploadData(
              allMassUploadData.filter(
                (x) =>
                  x.condition.toLowerCase() !== "valid" &&
                  x.condition.toLowerCase() !== "conflicting effective dates"
              )
            );
            setActiveTab(0);

            toast.fire(
              "Success",
              "All valid Agreements was uploaded successfully",
              "success"
            );
            agmtRefetch();
          } else {
            toast.fire(
              "Adding New Agreement Failed",
              "Server Error: Cannot add new Agreement",
              "error"
            );
          }
        }
      },
      onError: (err) => {
        setUploading(false);
        toast.fire("Adding new Agreement Failed", err, "error");
      },
    });
  };

  const hasValidData = massUploadData?.some(
    (el) =>
      el.condition.toLowerCase() === "valid" ||
      el.condition.toLowerCase() === "conflicting effective dates"
  );
  const deletePermission =
    PERMISSIONS.permission_carrieragreemnentmgmt_agreement_delete;

  return (
    <div className="-mx-10 px-5">
      {hasValidData && (
        <div className="pb-2 mb-6 mx-8 -mt-6 flex justify-end">
          <SaveButton
            onClick={() => {
              setOpenConfirm(true);
            }}
            disabled={isEditState}
            buttonValue={uploading ? "Saving..." : "Save"}
          />
        </div>
      )}

      <div className="px-6">
        <Table
          columns={columns}
          data={massUploadData}
          customStyles={{
            ...localCustomStyles,
            table: {
              style: {
                overflow: "auto",
                maxHeight: "300px",
              },
            },
          }}
          pagination={!isEditState}
          selectableRows={massUploadData?.length > 0 ? true : false}
          onSelectedRowsChange={onSelectedRowsChange}
          selectedRows={selectedRows}
          setOpenModal={setOpenModal}
          setIsBulkSelected={setIsBulkSelected}
          clearSelectedRows={clearSelectedRows}
          deletePermission={deletePermission}
          loading={isLoading}
        />
      </div>

      <ConfirmBoxModal
        ModalTitle={"Mass Upload Agreement"}
        qConfirmation={`Are you sure you want to save these data?`}
        isOpen={openConfirm}
        onClose={() => setOpenConfirm(false)}
        onClickFunction={() => {
          handleSave();
        }}
      />
    </div>
  );
};
